import { CalendarEventType } from './Calendar'

export interface OccasionalSlot {
    id: number
    groupId: string
    daycareId: number
    sectionId: number | null
    childId: number | null
    childName: string | null
    childComplement: string | null
    parentName: string | null
    parentId: number | null
    section: string | null
    parentComment: string | null
    date: string
    start: string
    end: string
    type: CalendarEventType
    matching: Array<number>
    limit: Array<OccasionalSlotLimit> | null
    scheduled: string | null
    expiry: string | null
    created: string
    updated: string
    internalNote: string | null
    externalNote: string | null
    externalIcon?: OccasionalSlotIcon
    priorityGroup: Array<OccasionalSlotPriorityGroup>
    priorityChild: Array<OccasionalSlotPriorityChild>
    placeId: number | null
    placeName?: string
    placeAddress?: string
}

export type OccasionalSlotLimit = {
    childId: number
    limit: number
}

export type OccasionalSlotPriorityGroup = {
    id: number
    name: string
}

export type OccasionalSlotPriorityChild = {
    id: number
    firstname: string
}

export enum OccasionalSlotIcon {
    None = 'None',
    MusicNote = 'MusicNote',
    Blender = 'Blender',
    Forest = 'Forest',
    Restaurant = 'Restaurant',
    Hotel = 'Hotel',
    MenuBook = 'MenuBook',
    Brush = 'Brush',
    SportTennis = 'SportTennis',
    Attractions = 'Attractions',
    BeachAccess = 'BeachAccess',
    Cake = 'Cake',
    Check = 'Check',
    CrueltyFree = 'CrueltyFree',
    ChildFriendly = 'ChildFriendly',
    TheaterComedy = 'TheaterComedy',
    SelfImprovement = 'SelfImprovement',
    Pool = 'Pool',
    SignLanguage = 'SignLanguage',
    Rocket = 'Rocket'
}

export type EditChildValidatedOccasionalSlot = {
    slotId: number
    childId: number
    childName: string
    childComplement: string | null
}

export interface Absence {
    parentComment?: string | null
    daycareComment?: string | null
    regularSlotId: number
    date: string
    start?: string
    end?: string
    childName?: string | null
    childComplement?: string | null
    childId?: number
    parentId?: number
    parentName?: string | null
}

export interface RegularUpdate {
    date: Date
    start: Date
    end: Date
    regularSlotId?: number
    childName?: string | null
    childComplement?: string | null
    childId?: number
    parentId?: number
    parentName?: string | null
}

export interface RegularCancellationRequest {
    id: number
    start: string
    end: string
    date: string
    reason: string
    regularSlotId?: number
    regularSlotStart?: string
    regularSlotEnd?: string
    childName?: string | null
    childComplement?: string | null
    childId?: number
    parentId?: number
    parentName?: string | null
    requestDate?: string
    placeId: number | null
    placeName?: string
    placeAddress?: string
}

export interface RegularSlot {
    id: number
    daycareId: number
    childName: string | null
    childComplement: string | null
    childId: number
    sectionId: number | null
    sectionName: string | null
    parentId: number
    parentName: string | null
    day: number
    start: string
    end: string
    date: string
    absence: boolean
    parentComment?: string | null
    daycareComment?: string | null
    type: CalendarEventType
    cancellationRequests: Array<RegularCancellationRequest>
    placeId: number | null
    placeName?: string
    placeAddress?: string
    created: Date
    updated: Date
}

export interface RequestSlot {
    id: number
    daycareId: number
    childId: number
    childName: string
    childComplement: string
    sectionName: string
    comment: string | null
    date: string
    start: string
    end: string
    parentId: number
    parentName: string
    requestDate?: string
}

export interface MutateOccasionalSlot {
    id: number
    date: string
    start: string
    end: string
    childId: number | undefined
    sectionId: number
    childrenPriority: Array<number>
    groupPriority: Array<number>
    scheduled: string | undefined
    expiry: string | undefined
    internalNote: string | undefined
    externalNote: string | undefined
    externalIcon: OccasionalSlotIcon | undefined
    placeId: number | undefined
}

export type NewOccasionalSlot = Omit<MutateOccasionalSlot, 'id'>

export type UpdateOccasionalSlot = MutateOccasionalSlot

export interface OccasionalSlotsPlaces {
    id: number
    name: string
    address: string
}

export type CreateChildRequestSlot = {
    childId: number
    childName: string
    childComplement?: string
}
export type OverlappingSlot = {
    start: Date
    end: Date
    date: string
    slotId: number
    slotType: CalendarEventType
    childId?: number
    childName?: string
    childComplement?: string
    placeName?: string
}

export type ResultCreateRegularSlot = {
    occasionalSlots: OverlappingSlot[]
    regularSlots: OverlappingSlot[]
    requestSlots: OverlappingSlot[]
    otherSlots: OverlappingSlot[]
}

export type EventRegularOverlap = {
    title: string
    date: Date
    start: Date
    end: Date
    slotId: number
    childId?: number
    type: CalendarEventType
}

export type slotIdAndDateAndChildId = {
    slotId: number
    date: string
    childId: number
}
